import React from "react";
import { Button, Spinner } from "react-bootstrap";
import { Redirect } from "react-router-dom";
import BootstrapTable from "react-bootstrap-table-next";
import { fetchVolunteers } from "./services/DataService";
import "./style/volunteer.scss";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";

class Volunteer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      volunteers: [],
    };
  }

  componentDidMount() {
    this.setState({ loading: true });
    fetchVolunteers().then((volunteers) => {
      this.setState({ loading: false, volunteers: volunteers });
    });
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to={this.state.redirect} />;
    }
    if (this.state.loading) {
      return (
        <Spinner animation="border" role="status" className="kugs-spinner">
          <span className="sr-only">Loading...</span>
        </Spinner>
      );
    }
    const rowEvents = {
      onClick: (e, row, rowIndex) => {
        this.setState({ redirect: `/volunteers/${row.id}` });
      },
      onMouseEnter: (e, row, rowIndex) => {
        e.target.parentNode.className = "row-enter";
      },
      onMouseLeave: (e, row, rowIndex) => {
        e.target.parentNode.className = "row-leave";
      },
    };
    let sortCarets = (order, column) => {
      if (!order)
        return (
          <span className="sort-glyph-group">
            <span className="sort-glyph-both glyphicon glyphicon-triangle-top"></span>
            <span className="sort-glyph-both glyphicon glyphicon-triangle-bottom"></span>
          </span>
        );
      else if (order === "asc")
        return (
          <span className="sort-glyph glyphicon glyphicon-triangle-top"></span>
        );
      else if (order === "desc")
        return (
          <span className="sort-glyph glyphicon glyphicon-triangle-bottom"></span>
        );
      return null;
    };
    return (
      <div>
        <Button
          variant="primary"
          href="/volunteers/add"
          className="glyphicon glyphicon-plus btn-add"
        >
          <div className="hidden">Add</div>
        </Button>
        <BootstrapTable
          keyField="id"
          data={this.state.volunteers}
          rowEvents={rowEvents}
          columns={[
            {
              dataField: "username",
              text: "Username",
              sort: true,
              sortCaret: sortCarets,
            },
            {
              dataField: "wid",
              text: "W#",
              sort: true,
              sortCaret: sortCarets,
            },
            {
              dataField: "first",
              text: "First",
              sort: true,
              sortCaret: sortCarets,
            },
            {
              dataField: "last",
              text: "Last",
              sort: true,
              sortCaret: sortCarets,
            },
            {
              dataField: "status",
              text: "Status",
            },
          ]}
        />
      </div>
    );
  }
}

export default Volunteer;
